// The viewer stream URL from cme-common's session.data.streaming. The backend has used a
// few spellings for the field - and sometimes sends a list (first non-empty entry wins).
// One helper for every reader, so the Stream Health card and Go Live check exactly the
// same URL - and share one playing status (hooks/useStreamPlayback.js). "" when none.
export function streamingUrlOf(streaming) {
  const raw =
    streaming?.steaming_url ||
    streaming?.streaming_url ||
    streaming?.url ||
    streaming?.steamingUrl;
  if (Array.isArray(raw)) return raw.find(Boolean) || "";
  return raw || "";
}
